/**
 * Mobile number: 10 digits only, cannot start with 0.
 * Display format: "12345 67890" (5 digits, space, 5 digits).
 */

/** Format digits for display: "12345 67890" */
export function formatMobileDisplay(digits) {
  if (!digits) return ""
  const d = String(digits).replace(/\D/g, "").slice(0, 10)
  if (d.length <= 5) return d
  return d.slice(0, 5) + " " + d.slice(5, 10)
}

/**
 * Parse input for mobile: numbers only, no leading zero, max 10 digits.
 * Returns only the allowed digits string.
 */
export function parseMobileInput(raw) {
  const digits = String(raw).replace(/\D/g, "")
  const noLeadingZero = digits.replace(/^0+/, "") || ""
  return noLeadingZero.slice(0, 10)
}

/** Validate: exactly 10 digits, first digit 1-9 (not 0) */
export function isValidMobileNumber(digits) {
  return /^[1-9]\d{9}$/.test(String(digits).replace(/\D/g, ""))
}
